import { render } from "./Carrossel.vue?vue&type=template&id=5c8d9029&scoped=true"
import script from "./Carrossel.vue?vue&type=script&lang=js"
export * from "./Carrossel.vue?vue&type=script&lang=js"

import "./Carrossel.vue?vue&type=style&index=0&id=5c8d9029&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8d9029"]])

export default __exports__